import axios, { type AxiosPromise } from 'axios'
import { BANKING_API_ENDPOINT } from 'shared/envs'

import { type CustomAxiosRequestConfig } from '~/domains/platform/infra/http/http-client-factory'

import { keysToSnakecase, responseSuccessInterceptor, transformResponse } from './http-helpers'

const simpleInstance = axios.create({
  baseURL: BANKING_API_ENDPOINT(),
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])]
})

simpleInstance.interceptors.response.use(responseSuccessInterceptor)

export const simpleHttpClient = async <T>(config: CustomAxiosRequestConfig = {}) => {
  return simpleInstance({ ...config }) as AxiosPromise<T>
}
